import { h } from 'preact';
import AppLayout from './layouts/AppLayout';
import store from '../store';
import { siteType, userType } from '../../includecart/propTypes';
import StripeConnectButton from './auth/StripeConnectButton';
import Toggle from './ui/Toggle';
//import * as siteActions from '../actions/site';

function SiteView(props) {
  let { site } = props;
  let isStripeConnected = site.accounts && site.accounts.stripe && site.accounts.stripe.stripe_publishable_key;
  let stripePubKey = (site.accounts && site.accounts.stripe && site.accounts.stripe.stripe_publishable_key) || false;

  return (
    <AppLayout backUrl="/account/sites" title={site.title} data-component="SiteView" >
      <h2 className="section-header">Site Information</h2>
      <div className="card">
        <div className="content-padded">
          <p>SiteId: {site.id}</p>
          <p>Title: {site.title}</p>
          <p>Domain: {site.domain}</p>
        </div>
      </div>

      <h2 className="section-header">Stripe Connect</h2>
      <div className="card">
        <div className="content-padded">
          {isStripeConnected ? <p><strong>Stripe account already connected</strong>. You can re-connect again, but the new connection will replace the existing one.</p> : <p>Connect your Stripe account to get started!</p>}
          <p><StripeConnectButton site={site} /></p>
          {isStripeConnected ? <p>Publishable Key: <code>{stripePubKey}</code></p> : null}
        </div>
      </div>

      <h2 className="section-header">Embed Code</h2>
      <div className="card">
        <div className="content-padded">
          <p>Use this code to embed IncludeCart on your website:</p>
          <pre>
            &lt;script src=&quot;https://static.includecart.com/js/includecart.js&quot; data-ic-siteId={site.id} data-ic-stripePubKey={stripePubKey} defer&gt;&lt;/script&gt;
          </pre>

          <p>List of all products in your store (with pictures):</p>
          <pre>
            &lt;div class=&quot;ic_productList&quot;&gt;[ Loading Product List... ]&lt;/div&gt;
          </pre>

          <p>Single product display tile (with picture):</p>
          <pre>
            &lt;div class=&quot;ic_productTile&quot; data-ic-productId=&quot;prod_abc123StripeId&quot;&gt;[ Loading Product... ]&lt;/div&gt;
          </pre>
        </div>
      </div>

      <h2 className="section-header">Ready to go live?</h2>
      <div className="card">
        <div className="content-padded">
          <Toggle name="isLive">Live Mode</Toggle>
          <p>Putting your account in &quot;Live Mode&quot; to take real orders requires payment of <strong>$49/year per site</strong>. There are no other fees or limitations.</p>
        </div>
      </div>
    </AppLayout>
  );
}

SiteView.propTypes = {
  site: siteType.isRequired,
  user: userType.isRequired,
};

export default store.connect(SiteView, {
  user: 'user',
});
